/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectStatusColumnDropdown_columns = ReadonlyArray<{
    readonly node: {
        readonly order: number | null;
        readonly name: string | null;
        readonly id: string;
        readonly projectGroupStatusColumnId: number | null;
    } | null;
    readonly " $refType": "ProjectStatusColumnDropdown_columns";
}>;
export type ProjectStatusColumnDropdown_columns$data = ProjectStatusColumnDropdown_columns;
export type ProjectStatusColumnDropdown_columns$key = ReadonlyArray<{
    readonly " $data"?: ProjectStatusColumnDropdown_columns$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectStatusColumnDropdown_columns">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ProjectStatusColumnDropdown_columns",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "order",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectGroupStatusColumnId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StatusColumnV2TypeEdge"
};
(node as any).hash = '9e4e206e9751fabce9e60e75f24080c7';
export default node;
